import { Navigate, Outlet } from "react-router-dom";


const AdminGate = ({ children, roleRequired }) => {
  const role = localStorage.getItem('role');

  if (!role) {
    return <Navigate to="/login" />;
  }

  if (role !== roleRequired) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default AdminGate;